import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ReadPost from '../views/ReadPost.vue' // ✅ Import ReadPost

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: "Ajie Genrald" }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: { title: 'About',  bgImage: 'https://us1.ajieblogs.eu.org/cdn/img/public/ajiedevserver/nova-ai/1772939726941.png',
      bgOpacity: 0.60, // darkness level (0–1)
      bgPosition: 'center center',
      bgSize: 'cover' }
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('../views/PortfolioView.vue'),
    meta: { title: 'Portfolio' }
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/BlogView.vue'),
    meta: { title: 'Blogs' }
  },
  {
    path: '/public-lavalink',
    name: 'public-lavalink',
    component: () => import('../views/ArticleView.vue'),
    meta: { title: 'Free Public Lavalink Hosting' }
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth.vue'),
    meta: { title: 'Web Verification',  bgImage: 'https://ajie.is-a.dev/cdn/img/AjieDevHelper-AI_WhalesBG-WLC-Prod-V2.jpg',
      bgOpacity: 0.55, // darkness level (0–1)
      bgPosition: 'center center',
      bgSize: 'cover' }
  },
  {
    path: '/read/:slug',
    name: 'read-post',
    component: ReadPost,
    meta: { title: 'Read Post' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || "/"), // ✅ Use fallback "/"
  routes
});


router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - Genrald's` : "Genrald's"; // ✅ Default title if no meta.title
  next();
});

export default router;
